import { render, staticRenderFns } from "./mobileSwiper.vue?vue&type=template&id=c0f5d570&"
import script from "./mobileSwiper.vue?vue&type=script&lang=js&"
export * from "./mobileSwiper.vue?vue&type=script&lang=js&"
import style0 from "./mobileSwiper.vue?vue&type=style&index=0&id=c0f5d570&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports